import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalTuition from '../../_components/ModalTuition/ModalTuitionController';
import IconMask from '../../../assets/icons/Mask.svg';
// import ImageBookMark from '../../../assets/icons/bookmark.svg';
import ImageBibliotecaBook from '../../../assets/icons/BibliotecaBook.svg';
import { Creators as procedureActions } from '../../../domain/useCases/procedures/getProcedureInformation';
import IconBeneficios from '../../../assets/icons/home/beneficio.svg';
import IconClass from '../../../assets/icons/home/class.svg';
import IconUTPClass from '../../../assets/icons/home/utp-class.svg';
import IconInfo from '../../../assets/icons/home/info.svg';
import IconUTPInfo from '../../../assets/icons/home/utp-info.svg';
import IconSmallCrosses from '../../../assets/icons/home/smallCrosses.svg';

// import IconTutorial from '../../../assets/icons/Tutorial.svg';
import IconRefInst from '../../../assets/icons/home/info-institu.svg';
import IconAlumnNuev from '../../../assets/icons/home/alumnos-nuevos.svg';

import ImageEnrollmentSurveySmall from '../../../assets/icons/home/enrollmentSurvey.svg';
// import IconRecNota from '../../../assets/icons/home/notas.svg';
// import IconCertProg from '../../../assets/icons/home/certi-prog.svg';
import IconBolsa from '../../../assets/icons/home/bolsa-trabajo.svg';
import IconEmpleabilidad from '../../../assets/icons/home/empleabilidad.svg';
import IconBoletin from '../../../assets/icons/home/boletin.svg';
import IconConstEst from '../../../assets/illustrations/ilustracion_tramites.svg';
import notPendientes from '../../../assets/icons/home/casuisticas/not-courses.svg';
import IconMatri from '../../../assets/icons/icon-matri.svg';
import IconNext from '../../../assets/icons/chevron-right-blank.svg';
import IconHorMatri from '../../../assets/icons/home/horarios-matri.svg';
import IconCatalogo from '../../../assets/icons/home/catalogos.svg';

import IconExternal from '../../../assets/icons/external-link.svg';
import IDHelpers from '../../../core/helpers/IDHelper';
import CardSchedule from './componentsv2/cardSchedule';
import FooterView from '../../_components/footer/FooterView';
import useTutorial from '../../hooks/useTutorial';
// import ModalConfirmation from '../procedures/components/Modal/Modal';
import Spinner from '../../components/Spinner';
import ModalPendDocs from '../../_components/ModalPendDocs/ModalPendDocsController';
import HomeHeader from './components/HomeHeader';
import procedure from '../procedures/constants/index';

import {
  Container,
  WrapperContainer,
  SectionCardTitle,
  Title,
  Button,
  SectionCardContainer,
  Tramite,
  TramiteCardTitle,
  TramiteCardParaphap,
  TramiteCardContainer,
  BlockTramite,
  TramiteCardImgen,
  TramiteTitle,
  TramiteCardIcon,
  CardCourse2,
  ImageBookmark,
  BlockCourse,
  ParagraphCourse,
  SectionInterests,
  InterestsTitle,
  RowCardInterests,
  CardInterests,
  ImagenInterests,
  ContainerInterests,
  TitlesInterests,
  TitleInterests,
  SubTitleInterests,
  ButtonIconLink,
  IconExternalLink,
  HeaderInitiation,
  SectionMatricula,
  SectionCard2,
  SectionShedule,
  SectionRol,
  ContainerInterestsExternal,
  TitlesInterestsExternal,
  Wrapper
} from './styles';
import useExternalSettings from '../../hooks/useExternalSettings';
import routes from '../../components/Routes/routingMap';
import ModalSchedule from './components/ModalSchedule/ModalSchedule';
import ContainerSchedule from './components/ModalSchedule/ContainerSchedule';
import { GlobalStyles } from '@/presentation/components/LightBox';
import ModalZoom from './components/ModalZoom';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import useVersionCheck from '@/presentation/hooks/useVersionCheck';
import Link from '@/presentation/reusables/Link';
import useSelectProcedure from '@/presentation/hooks/useSelectProcedure';
import useProfile from '@/presentation/hooks/useProfile';
// INICIO COMPONENTS FOR JOYRIDE

// NUEVOS ESTILOS

const HomeView = (props: any) => {
  const {
    data,
    dataVersion,
    handlerRedirectNewPage,
    handlerRedirectBulletin,
    handlerRedirectBenefit,
    handlerRedirectPage,
    DayAndMonth,
    isCruce,
    isLoading,
    dataModality,
    modalSchedule,
    ScheduleResumeHome,
    newStudent,
    showPopupEnrolmentTurn,
    handlerHideEnrolmentTurn
  } = props;
  const dispatch = useDispatch();
  const { showTutorial } = useTutorial();
  const { openSchedule, setOpenSchedule } = modalSchedule;
  const [, setShowModalStorage] = useState(false);
  const [storageChange] = useState(0);
  const [showPendDocs, setShowPendDocs] = useState(true);
  const { procedureInHome } = useExternalSettings();
  const [selectedProcedure, setSelectedProcedure] = useState(0);
  const { academic } = useProfile();
  const { evalRedirect } = useSelectProcedure();
  const { checkVersion } = useVersionCheck();
  const { isGraduated } = academic;

  const handleTramiteRedirect = (procedureId: number) => {
    GoogleAnalytics.writeLog('portal-home-clickVariableProcessingCard', 'home');
    setSelectedProcedure(procedureId);
    dispatch(
      procedureActions.getProcedureInformation(
        procedureId,
        isGraduated ? 'EGRE' : ''
      )
    );
  };

  useEffect(() => {
    if (dataVersion) {
      checkVersion(dataVersion.version);
    }
  }, [dataVersion]);

  const {
    isRolExam,
    isEnrollmentTurn,
    isCourseCatalog,
    isEnrollmentCardEnabled,
    // isProgressiveCertification,
    isIntentionEnrollment,
    isEnrollmentButtonEnabled,
    enrollmentPeriodName,
    enablePendDocs,
    currentPeriod
  } = useExternalSettings();

  const periodData = useSelector((state: any) =>
    state.getPeriods?.data?.filter((period: any) => period.isCurrent === true)
  );

  const studentInPeriodCurrent = () => {
    if (periodData && periodData.length > 0) {
      return Number(periodData[0].period) === Number(currentPeriod);
    }
    return false;
  };

  const validateModalStep = () => {
    const StepLocal = localStorage.getItem('__STEP_HIDDE');
    if (StepLocal === null) {
      setShowModalStorage(true);
    }

    if (StepLocal && JSON.parse(StepLocal)) {
      setShowModalStorage(false);
    }

    if (StepLocal && JSON.parse(StepLocal) === false) {
      setShowModalStorage(true);
    }

    if (StepLocal && JSON.parse(StepLocal) === null) {
      setShowModalStorage(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      validateModalStep();
    };

    // Escuchar el evento personalizado
    window.addEventListener('local-storage-changed', handleStorageChange);

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('local-storage-changed', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    validateModalStep();
  }, [storageChange]);

  useEffect(() => {
    if (selectedProcedure !== 0) {
      evalRedirect(selectedProcedure);
    }
  }, [selectedProcedure]);

  return (
    <div data-testid="cmp-home-view">
      <HomeHeader />
      {dataModality && (
        <WrapperContainer>
          <Container paddingZero>
            <Wrapper>
              {/* <b className="modName">Paga hoy</b> la primera cuota y accede a un
              <b className="modName"> dscto. de hasta 5%. </b>
              Mira el{' '}
              <a
                style={{
                  textDecoration: 'underline'
                }}
                target="_black"
                href="https://view.genial.ly/62f289509f74f500192144dc"
              >
                calendario de pagos.
              </a> */}
              {/* Por disposición de SUNEDU, desde enero 2023 deberás estudiar en la
              modalidad de estudio en la que estás inscrito. Actualmente estás
              en <b className="modName">modalidad {dataModality?.desc}</b>. Para
              escoger opciones más flexibles,{' '} */}
              La modalidad en que estás inscrito es:{' '}
              <b className="modName">Modalidad {dataModality?.desc}</b>
              {/* <button
                type="button"
                style={{ textDecoration: 'underline' }}
                data-testid="cmp-modalidad-haz-click"
                onClick={() => {
                  handlerRedirectPage(
                    routes.student.procedures.categories.requests 
                      .changeStudiesOption.procedureinfo
                  );
                }}
              >
                haz click aquí
              </button>{' '}
              . */}
            </Wrapper>
          </Container>
        </WrapperContainer>
      )}
      <HeaderInitiation>
        {newStudent && isEnrollmentTurn && isEnrollmentButtonEnabled && (
          <SectionMatricula>
            <button
              data-testid="cmp-btn-conoce-matricula"
              onClick={() =>
                handlerRedirectPage(routes.student.main.registrationShift)
              }
              formTarget="_blank"
              type="button"
              className="container__hero"
            >
              <div className="hero">
                <img src={IconMatri} alt="IconMatri" />
                <p>Conoce tu turno de matrícula ¡aquí!</p>
              </div>
              <img src={IconNext} alt="IconNext" />
            </button>
          </SectionMatricula>
        )}
      </HeaderInitiation>
      <WrapperContainer>
        <Container>
          <SectionCard2>
            <SectionShedule>
              <SectionCardTitle>
                <Title>
                  <strong>Hoy, </strong>
                  <span style={{ fontWeight: '400' }}>{DayAndMonth?.day}</span>
                </Title>
                <Button
                  data-testid="cmp-btn-horario"
                  onClick={() => {
                    GoogleAnalytics.writeLog(
                      'boton-horariomatriculado',
                      'schedule-modal'
                    );
                    setOpenSchedule(true);
                  }}
                >
                  Ver mi horario
                </Button>
              </SectionCardTitle>

              <SectionCardContainer dataLength={data?.length}>
                {isLoading && <Spinner height={68} colorText="#161D1F" />}

                {data && data.length === 0 && (
                  <div className="container__courses--blank">
                    <img
                      className="not__pendientes"
                      src={notPendientes}
                      alt="no hay pendientes"
                    />
                    <h1>No hay más pendientes por hoy</h1>
                  </div>
                )}

                {data?.map((meeting: any, numero: any) => (
                  <CardSchedule
                    handlerRedirectPage={handlerRedirectPage}
                    key={`meet-${IDHelpers.generateID()}`}
                    title={meeting?.name}
                    startTime={meeting?.start}
                    endTime={meeting?.end}
                    type={meeting?.type}
                    location={meeting?.location?.classRoom?.id}
                    isReprog={meeting.isReprog}
                    isCruce={isCruce}
                    numero={numero}
                    instructionMode={meeting?.instructionMode}
                  />
                ))}
              </SectionCardContainer>
            </SectionShedule>
            {isRolExam && !isGraduated && studentInPeriodCurrent() && (
              <SectionRol>
                También puedes ver tu{' '}
                <Link
                  linkType="internal"
                  url={routes.student.main.examRol}
                  linkName="rol de exámenes aquí"
                  onClick={() =>
                    GoogleAnalytics.writeLog(
                      'portal-home-clickExamRole',
                      'home'
                    )
                  }
                />{' '}
              </SectionRol>
            )}

            {/* <SectionTramite> */}
            <Tramite>
              <TramiteCardTitle>
                <TramiteCardParaphap>
                  Realiza tus trámites y conoce su estado:
                </TramiteCardParaphap>
                <Button
                  data-testid="cmp-btn-tramite"
                  onClick={() => handlerRedirectPage('/tramites')}
                >
                  Ir a trámites
                </Button>
              </TramiteCardTitle>
              {procedure.listProcedure
                .filter((proced) => proced.procedureId === procedureInHome)
                .map((foundProcedure) => (
                  <TramiteCardContainer
                    data-testid="cmp-btn-constancia-estudios"
                    key={foundProcedure.procedureId}
                    onClick={() =>
                      handleTramiteRedirect(foundProcedure.procedureId)
                    }
                  >
                    {/* <ButtonTramite type='button'> */}
                    <TramiteCardImgen src={IconConstEst} />
                    <BlockTramite>
                      <TramiteTitle>{foundProcedure.name}</TramiteTitle>
                      {/* <TramiteSubTitle>O encuentra más</TramiteSubTitle> */}
                    </BlockTramite>
                    <TramiteCardIcon src={IconMask} />
                    {/* </ButtonTramite> */}
                  </TramiteCardContainer>
                ))}
            </Tramite>
            <div id="linksportal" />
            {/* </SectionTramite> */}
          </SectionCard2>

          <SectionInterests>
            <InterestsTitle>Otros enlaces:</InterestsTitle>
            <RowCardInterests>
              <CardCourse2>
                <BlockCourse
                  data-testid="cmp-btn-alumnos-nuevos"
                  onClick={(e) =>
                    handlerRedirectNewPage(
                      'https://info.utp.edu.pe/subcategoria/CAT023',
                      e
                    )
                  }
                  formTarget="_blank"
                  type="button"
                >
                  <ImageBookmark src={IconAlumnNuev} />
                  <ParagraphCourse>Ruta de alumnos nuevos 2025</ParagraphCourse>
                </BlockCourse>
              </CardCourse2>

              <CardCourse2>
                {/* <BlockCourse
                  data-testid="cmp-btn-nuevo-plan-estudios"
                  className="step2"
                  onClick={() =>
                    handlerRedirectNewPage(
                      'https://portalestudiante02.utp.edu.pe/PlanEstudios/NuevoPlanEstudios'
                    )
                  }
                  formTarget="_blank"
                  type="button"
                >
                  <ImageBookmark src={IconNuePlanEstu} /> 
                  <ParagraphCourse>Nuevo plan de estudios</ParagraphCourse>
                </BlockCourse> */}

                <BlockCourse
                  data-testid="cmp-btn-info-institucional"
                  onClick={() =>
                    handlerRedirectPage('/inicio/informacion-institucional')
                  }
                  formTarget="_blank"
                  type="button"
                >
                  <ImageBookmark src={IconRefInst} />
                  <ParagraphCourse>Información institucional</ParagraphCourse>
                </BlockCourse>
              </CardCourse2>
            </RowCardInterests>
          </SectionInterests>

          {/* Matrícula */}

          {(isCourseCatalog ||
            isIntentionEnrollment ||
            isEnrollmentCardEnabled) && (
            <SectionInterests>
              <InterestsTitle>Matrícula:</InterestsTitle>

              <RowCardInterests>
                {newStudent && isCourseCatalog && (
                  <CardInterests
                    data-testid="cmp-btn-conoce-matricula2"
                    onClick={() =>
                      handlerRedirectPage(routes.student.main.courseCatalog)
                    }
                    formTarget="_blank"
                    type="button"
                  >
                    <ImagenInterests src={IconCatalogo} />
                    <ContainerInterests>
                      <TitlesInterests>
                        <TitleInterests>
                          Catálogo de cursos y horarios {enrollmentPeriodName}
                        </TitleInterests>
                        {/* <SubTitleInterests>
                          Revisa los cursos disponibles para el siguiente ciclo
                        </SubTitleInterests> */}
                      </TitlesInterests>

                      {/* <ButtonIconLink>
                        <IconExternalLink src={IconExternal} />
                      </ButtonIconLink> */}
                    </ContainerInterests>
                  </CardInterests>
                )}
                {isEnrollmentCardEnabled && newStudent && (
                  <CardInterests
                    data-testid="cmp-btn-conoce-matricula3"
                    onClick={() => {
                      GoogleAnalytics.writeLog(
                        'boton-horariosdematricula',
                        'enrolment-turn-emb'
                      );
                      handlerRedirectPage(
                        routes.student.main.registrationShift
                      );
                    }}
                    formTarget="_blank"
                    type="button"
                  >
                    <ImagenInterests src={IconHorMatri} />
                    <ContainerInterests>
                      <TitlesInterests>
                        <TitleInterests>
                          Cursos y horarios de matrícula {enrollmentPeriodName}
                        </TitleInterests>
                        {/* <SubTitleInterests>
                          Revisa tus cursos y elige tus horarios del siguiente
                          ciclo.
                        </SubTitleInterests> */}
                      </TitlesInterests>

                      {/* <ButtonIconLink>
                        <IconExternalLink src={IconExternal} />
                      </ButtonIconLink> */}
                    </ContainerInterests>
                  </CardInterests>
                )}
                {isIntentionEnrollment && (
                  <CardInterests
                    data-testid="cmp-btn-conoce-matricula4"
                    onClick={() =>
                      handlerRedirectPage(routes.student.main.enrollmentSurvey)
                    }
                    formTarget="_blank"
                    type="button"
                  >
                    <ImagenInterests src={ImageEnrollmentSurveySmall} />
                    <ContainerInterests>
                      <TitlesInterests>
                        <TitleInterests>
                          Encuesta de matrícula para {enrollmentPeriodName}
                        </TitleInterests>
                        {/* <SubTitleInterests>Resuélvela</SubTitleInterests> */}
                      </TitlesInterests>
                    </ContainerInterests>
                  </CardInterests>
                )}
              </RowCardInterests>
            </SectionInterests>
          )}

          <SectionInterests>
            <InterestsTitle>Tus plataformas digitales:</InterestsTitle>

            <RowCardInterests>
              <CardInterests
                height="124px"
                width="264px"
                data-testid="cmp-btn-utp+info"
                onClick={(e) =>
                  handlerRedirectNewPage('https://info.utp.edu.pe/', e)
                }
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={IconInfo} margin="12px 0px 0px -8px" />

                <ImagenInterests
                  src={IconSmallCrosses}
                  height="18px"
                  margin="-5px 0px 0px -30px"
                />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal
                    style={{
                      alignItems: 'baseline',
                      margin: '8px 0px 0px 3px'
                    }}
                  >
                    <ImagenInterests src={IconUTPInfo} margin="0 0 12px 0" />
                    <TitleInterests
                      size="14px"
                      lineHeight="17px"
                      style={{ width: '150px' }}
                    >
                      Encuentra toda la información de la universidad.
                    </TitleInterests>
                  </TitlesInterestsExternal>
                </ContainerInterestsExternal>
              </CardInterests>
              <CardInterests
                height="124px"
                width="264px"
                data-testid="cmp-btn-utp+class"
                onClick={(e) => {
                  handlerRedirectNewPage('https://class.utp.edu.pe/', e);
                }}
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={IconClass} margin="12px 0px 0px -8px" />
                <ImagenInterests
                  src={IconSmallCrosses}
                  margin="-5px 0px 0px -30px"
                  height="18px"
                />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal
                    style={{
                      alignItems: 'baseline',
                      margin: '8px 0px 0px 3px'
                    }}
                  >
                    <ImagenInterests src={IconUTPClass} margin="0 0 12px 0" />
                    <TitleInterests
                      size="14px"
                      lineHeight="17px"
                      style={{ width: '150px' }}
                    >
                      Revisa el contenido de tus clases desde tu computadora o
                      celular.
                    </TitleInterests>
                  </TitlesInterestsExternal>
                </ContainerInterestsExternal>
              </CardInterests>
            </RowCardInterests>
          </SectionInterests>

          <SectionInterests>
            <InterestsTitle>Te podría interesar:</InterestsTitle>

            <RowCardInterests>
              <CardInterests
                data-testid="cmp-btn-beneficios"
                onClick={handlerRedirectBenefit}
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={IconBeneficios} />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal>
                    <TitleInterests>Beneficios</TitleInterests>
                    <SubTitleInterests>
                      Disfruta de promociones, descuentos y más en UTP
                    </SubTitleInterests>
                  </TitlesInterestsExternal>

                  <ButtonIconLink>
                    <IconExternalLink src={IconExternal} />
                  </ButtonIconLink>
                </ContainerInterestsExternal>
              </CardInterests>

              <CardInterests
                data-testid="cmp-btn-biblioteca"
                onClick={(e) =>
                  handlerRedirectNewPage('https://tubiblioteca.utp.edu.pe/', e)
                }
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={ImageBibliotecaBook} />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal>
                    <TitleInterests>Ingresa a biblioteca</TitleInterests>
                    <SubTitleInterests>
                      Encuentra recursos, libros y más
                    </SubTitleInterests>
                  </TitlesInterestsExternal>

                  <ButtonIconLink>
                    <IconExternalLink src={IconExternal} />
                  </ButtonIconLink>
                </ContainerInterestsExternal>
              </CardInterests>

              <CardInterests
                data-testid="cmp-btn-bolsa-trabajo"
                onClick={(e) =>
                  handlerRedirectNewPage('https://utp.hiringroomcampus.com/', e)
                }
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={IconBolsa} />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal>
                    <TitleInterests>Bolsa de trabajo</TitleInterests>
                    <SubTitleInterests>
                      Encuentra ofertas laborales exclusivas para ti
                    </SubTitleInterests>
                  </TitlesInterestsExternal>

                  <ButtonIconLink>
                    <IconExternalLink src={IconExternal} />
                  </ButtonIconLink>
                </ContainerInterestsExternal>
              </CardInterests>

              <CardInterests
                data-testid="cmp-btn-empleabilidad"
                onClick={(e) =>
                  handlerRedirectNewPage(
                    'https://www.utp.edu.pe/servicios-universitarios/empleabilidad',
                    e
                  )
                }
                formTarget="_blank"
                type="button"
              >
                <ImagenInterests src={IconEmpleabilidad} />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal>
                    <TitleInterests>Empleabilidad</TitleInterests>
                    <SubTitleInterests>
                      Conoce más sobre tu ruta laboral con UTP
                    </SubTitleInterests>
                  </TitlesInterestsExternal>

                  <ButtonIconLink>
                    <IconExternalLink src={IconExternal} />
                  </ButtonIconLink>
                </ContainerInterestsExternal>
              </CardInterests>

              <CardInterests
                onClick={handlerRedirectBulletin}
                formTarget="_blank"
                type="button"
                data-testid="cmp-btn-boletin"
              >
                <ImagenInterests src={IconBoletin} />
                <ContainerInterestsExternal>
                  <TitlesInterestsExternal>
                    <TitleInterests>Boletín informativo</TitleInterests>
                    <SubTitleInterests>
                      Entérate de las noticias más recientes de UTP
                    </SubTitleInterests>
                  </TitlesInterestsExternal>

                  <ButtonIconLink>
                    <IconExternalLink src={IconExternal} />
                  </ButtonIconLink>
                </ContainerInterestsExternal>
              </CardInterests>
            </RowCardInterests>
          </SectionInterests>
          <FooterView />
        </Container>
      </WrapperContainer>

      {isEnrollmentTurn && (
        <ModalTuition
          show={showPopupEnrolmentTurn}
          setShow={handlerHideEnrolmentTurn}
          showTutorial={showTutorial}
        />
      )}

      {enablePendDocs && (
        <ModalPendDocs
          show={showPendDocs && enablePendDocs}
          setShow={(v) => setShowPendDocs(v)}
          showTutorial={showTutorial}
        />
      )}

      {openSchedule && (
        <ModalSchedule
          showModal={openSchedule}
          handleClose={() => setOpenSchedule(false)}
          data-testid="cmp-modal-schedule"
        >
          {openSchedule ? <GlobalStyles /> : <></>}
          <ContainerSchedule
            ScheduleResumeHome={ScheduleResumeHome}
            handlerRedirectNewPage={handlerRedirectNewPage}
          />
        </ModalSchedule>
      )}
      {!showTutorial ? <ModalZoom /> : null}
    </div>
  );
};

export default HomeView;
